import { render, staticRenderFns } from "./makerequest.vue?vue&type=template&id=3937c304"
import script from "./makerequest.vue?vue&type=script&lang=js"
export * from "./makerequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports